import { TOGGLE_FEATURES } from 'configs/toggle-feature'
import { useDesktopView } from 'utils/hooks/useDesktopView'

export const usePelatihanMandiriDesktopView = () =>
  useDesktopView(TOGGLE_FEATURES.PELATIHAN_MANDIRI_DESKTOP_LANDING)
